var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "TheHeader" }, [
    _c("nav", { staticClass: "TheHeader_MainNav" }, [
      _c(
        "button",
        {
          staticClass: "TheHeader_IconButton",
          on: { click: _vm.openTreeDialog }
        },
        [_c("FontAwesomeIcon", { attrs: { icon: "search", size: "lg" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "TheHeader_IconLink", attrs: { href: _vm.topPath } },
        [_c("FontAwesomeIcon", { attrs: { icon: "home", size: "lg" } })],
        1
      ),
      _vm._v(" "),
      _vm.editable
        ? _c(
            "button",
            {
              staticClass: "TheHeader_IconButton",
              on: { click: _vm.openNewFileDialog }
            },
            [_c("FontAwesomeIcon", { attrs: { icon: "file", size: "lg" } })],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "TheHeader_PageTitle" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }